import React from "react";
 
const FeedbackPopup = props => {
  return (
    <td>
    <div className="feedback-popup-box">
      <div className="feedback-box">
        {/* <div className="feedback-close-icon" onClick={props.handleClose}><b>X</b></div> */}
        {props.content}
      </div>
    </div>
    </td>
  );
};

export default FeedbackPopup;